import React, { Component, Fragment } from "react";
import "../../styles/Popup.module.css";
import { Form, Select, Input, Button, Upload, Row, Col } from "antd";
import ImgCrop from "antd-img-crop";
import ReactDropzone from "react-dropzone";
import { connect } from "react-redux";
import { requestServerPost, selectBrand, selectPage } from "../../actions";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";

import { UploadOutlined, InboxOutlined } from "@ant-design/icons";
import PopupManager from "../../managers/PopupManager";
import path from "path";
import LayoutTemplates from "../../data/LayoutTemplates";
import ColorPicker from "../ColorPicker";
import Colors from "../../config/Colors";

const { Option } = Select;

const formItemLayout = {
  labelCol: { span: 0 },
  wrapperCol: { span: 24 },
};

class DuplicateTimelinePage extends Component {
  constructor(props) {
    super(props);
    const { data = null } = props;

    const timelineName = data ? data.TimelineName : "";

    if (!data || !data.BrandLogo || data.BrandLogo === "") {
      this.state = {
        timelinename: timelineName,
        fileList: [],
        files: [],
        data: data,
      };

      return;
    }

    this.state = {
      timelinename: timelineName,
      data: data,
      color: null,
    };
  }

  componentDidMount() {
    const { data = null } = this.props;

    if (data)
      this.setState({
        color: data.Color ? data.Color : Colors.defaulttimeline,
      });
    else this.setState({ color: Colors.defaulttimeline });
  }
  createTimelineLayout = (timelineID) => {
    const {
      requestServerPost,
      usertoken,
      data = null,
      selectedBrandData,
      campaignData,
    } = this.props;
    return new Promise((resolve, reject) => {
      var params = new FormData();
      params.append("brandid", selectedBrandData.BrandID);
      params.append("timelineid", timelineID);
      params.append("layout", JSON.stringify(LayoutTemplates.templates[0]));
      params.append("duration", 0);
      requestServerPost(
        "create_timelinelayout",
        params,
        {},
        (response) => {
          resolve();
        },
        usertoken,
      );
    });
  };
  onFinish = (values) => {
    const {
      requestServerPost,
      usertoken,
      data = null,
      selectedBrandData,
      campaignData,
    } = this.props;
    var params = new FormData();

    // console.log("campaignData " + JSON.stringify(campaignData))
    const { CampaignID } = campaignData;

    params.append("campaignid", CampaignID);

    if (!data) {
      params.append("brandid", selectedBrandData.BrandID);
      params.append("timelinename", values.timelinename);
      params.append("color", this.state.color);

      requestServerPost(
        "create_timeline",
        params,
        {},
        (response) => {
          const { timelineid } = response.data;

          this.createTimelineLayout(timelineid).then(() => {
            PopupManager.closePopup();
          });
        },
        usertoken,
      );
    } else {
      params.append("brandid", selectedBrandData.BrandID);
      params.append("timelineid", data.TimelineID);
      params.append("timelinename", values.timelinename);
      params.append("color", this.state.color);

      requestServerPost(
        "duplicate_timeline",
        params,
        {},
        (response) => {
          PopupManager.closePopup();
        },
        usertoken,
      );
    }
  };

  onColorChanged = (newcolor) => {
    this.setState({ color: newcolor });
  };
  render() {
    const { data = null } = this.props;
    const t = this.props.langT || PRO_TRANSLATIONS.en.duplicateTimelinePopup;
    const previewStyle = {
      display: "inline",
      width: 100,
      height: 100,
    };
    const color = data
      ? data.Color
        ? data.Color
        : Colors.defaulttimeline
      : Colors.defaulttimeline;
    return (
      <div className="popupcontentcontainer" style={{ height: "100%" }}>
        <Row style={{ width: "100%", height: "100%", padding: "24px" }}>
          <Col xs={24} lg={12} style={{ padding: "40px" }}>
            <div
              style={{
                fontSize: 38,
                fontWeight: 400,
                lineHeight: "42px",
                maxWidth: "250px",
                margin: "0 0 30px 0",
              }}
            >
              {data ? t.duplicateTitle : t.createTitle}
            </div>
            <Form
              name="validate_other"
              {...formItemLayout}
              onFinish={this.onFinish}
              key={data ? `${data.TimelineID}_edittimeline` : "_edittimeline"}
              initialValues={{
                ["timelinename"]: this.state.timelinename,
              }}
            >
              <Form.Item
                name="timelinename"
                label={t.nameLabel}
                rules={[{ required: true, message: t.nameValidation }]}
              >
                <Input
                  placeholder={t.namePlaceholder}
                  style={{ width: "100%", maxWidth: "250px" }}
                  onChange={(e) => {
                    this.setState({ timelinename: e.target.value });
                  }}
                />
              </Form.Item>
              {/* <Form.Item
                                name="brandcode"
                                rules={[{ required: true, message: 'Please input brand code!' }]}
                            >
                                <Input placeholder="Brand Code *" />
                            </Form.Item> */}

              <Form.Item
                wrapperCol={{ span: 12 }}
                style={{ marginTop: "20px" }}
              >
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                >
                  {data ? t.duplicateButton : t.createButton}
                </Button>
              </Form.Item>
            </Form>
          </Col>
          <Col xs={0} lg={12} style={{ float: "right" }}>
            <img
              style={{
                bottom: 0,
                right: 0,
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
              src="/cms/assets/svgs/decorations/decorate_createtimeline.svg"
            ></img>
          </Col>
        </Row>
      </div>
    );
  }
}

const Styles = {};

const mapStateToProps = (state) => {
  return {
    userdata: state.userdata,
    usertoken: state.usertoken,
    selectedBrandData: state.selectedBrandData,
  };
};

const ConnectedDuplicateTimelinePage = connect(mapStateToProps, {
  requestServerPost,
  selectPage,
})(DuplicateTimelinePage);

const DuplicateTimelinePageWithLang = (props) => {
  const { lang } = useProLanguage();
  const t =
    PRO_TRANSLATIONS[lang]?.duplicateTimelinePopup ||
    PRO_TRANSLATIONS.en.duplicateTimelinePopup;
  return <ConnectedDuplicateTimelinePage langT={t} {...props} />;
};

export default DuplicateTimelinePageWithLang;
